import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GetSearchResultsResponse } from '@shared/models/get-search-results-response';
import { EntertainmentSearchService } from '@shared/services/search/entertainment-search.service';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import * as EntertainmentSearchActions from '../actions/entertainment-search.actions';

@Injectable()
export class EntertainmentSearchEffects {
  constructor(private actions$: Actions, private entertainmentSearchService: EntertainmentSearchService) {}

  public getResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EntertainmentSearchActions.GET_RESULTS),
      concatMap((action: EntertainmentSearchActions.GetResults) => {
        const { page, selectedFilters, searchPhrase } = action.payload;

        return this.entertainmentSearchService.getEntertainmentResults(searchPhrase, selectedFilters, page).pipe(
          map(
            (response: GetSearchResultsResponse) =>
              new EntertainmentSearchActions.GetResultsSuccess({
                searchPhrase: searchPhrase,
                selectedFilters: selectedFilters,
                results: response.items,
                page: response.page,
                canLoadMore: response.canLoadMore,
                totalResults: response.totalItems,
                removeOldResults: action.payload.removeOldResults,
              })
          ),
          catchError((error: HttpErrorResponse) => of(new EntertainmentSearchActions.GetResultsFailure({ error })))
        );
      })
    )
  );
}
